/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgQuoteBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.49999 12H3.25C2.55962 12 2 11.4302 2 10.7273V6.27273C2 5.56979 2.55962 5 3.25 5H8.24999C8.94037 5 9.49999 5.56979 9.49999 6.27273V12ZM9.49999 12C9.49999 15.1818 8.24999 17.0909 4.5 19M22 12H15.75C15.0596 12 14.5 11.4302 14.5 10.7273V6.27273C14.5 5.56979 15.0596 5 15.75 5H20.75C21.4404 5 22 5.56979 22 6.27273V12ZM22 12C22 15.1818 20.75 17.0909 17 19"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
const SvgQuote = wrapIcon(SvgQuoteBase);
export default SvgQuote;
